/**
 * This class handles opening and closing the detail blocks.
 * 
 * @export
 * @class Detail
 */
import { getParameterByName } from '../helpers/utilities';

export class Detail {
    public id: string;
    private openEvent: Event;
    private closeEvent: Event;
    public isOpen: boolean;
    private content: HTMLElement;
    private dropdown: HTMLElement;
    private container: Element;
    private link: HTMLAnchorElement;
    private transitionDuration: number;

    constructor(container: Element) {
        this.container          = container;
        this.link               = <HTMLAnchorElement>this.container.querySelector('.js-detail__link');
        this.isOpen             = getParameterByName('detail') === getParameterByName('detail', this.link.href);
        this.id                 = <string>getParameterByName('detail', this.link.href);
        this.dropdown           = <HTMLElement>this.container.querySelector('.js-detail__dropdown');
        this.content            = <HTMLElement>this.container.querySelector('.js-detail__content');
        this.transitionDuration = parseFloat(getComputedStyle(this.dropdown).transitionDuration) * 1000;
        this.openEvent          = new CustomEvent('open', { detail: this });
        this.closeEvent         = new CustomEvent('close', { detail: this });
        
        // Scroll to it open page load if it's open
        if(this.isOpen) window.app.modules.global.scroll.animateScroll(this.container);

        this.link.addEventListener('click', (event) => {
            event.preventDefault();
            if(history.pushState) history.pushState('', '', this.link.href);

            this.toggle();
        });
    }


    /**
     * Toggles the detail based on it's current state.
     * 
     * @public
     * @memberof Detail
     */
    public toggle(): void {
        if(this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }


    /**
     * Opens the detail by animating the height.
     * 
     * @public
     * @memberof Detail
     */
    public open(): void {
        this.isOpen = true;

        this.container.dispatchEvent(this.openEvent);
        const contentHeight = this.content.offsetHeight;
        this.dropdown.style.height = `${contentHeight}px`;
        setTimeout(() => {
            this.dropdown.style.height = '';
            this.container.classList.add('o-detail--is-open');
            window.app.modules.global.scroll.animateScroll(this.container);
        }, this.transitionDuration);
    }


    /**
     * Closes the detail by animating the height.
     * 
     * @public
     * @memberof Detail
     */
    public close(): void {
        this.isOpen = false;

        this.container.dispatchEvent(this.closeEvent);
        const contentHeight = this.content.offsetHeight;
        this.dropdown.style.height = `${contentHeight}px`;
        setTimeout(() => {
            this.dropdown.style.height = '';
            this.container.classList.remove('o-detail--is-open');
        }, 20);
    }
}
